import { render, staticRenderFns } from "./table.pp36NTST.vue?vue&type=template&id=d0136880&scoped=true"
import script from "./table.pp36NTST.vue?vue&type=script&lang=js"
export * from "./table.pp36NTST.vue?vue&type=script&lang=js"
import style0 from "./table.pp36NTST.vue?vue&type=style&index=0&id=d0136880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0136880",
  null
  
)

export default component.exports